import React from 'react';
import { useHistory } from 'react-router-dom';
import { useGetPublisherQuery } from '../../api/publisherApiSlice';
import Title from '../../components/Title';
import { useTranslation } from 'react-i18next';
import { CredentialBlock } from '../../components/publisher/CredentialBlock';
import {useGetCurrentUserQuery} from "../../api/userApiSlice";

const Credentials = () => {
  const { data: {publisherId} = {}, isCurrentUserSuccess } = useGetCurrentUserQuery()
  const { data: publisher, isSuccess } = useGetPublisherQuery({publisherId}, { skip: !publisherId })
	const { t } = useTranslation();
  const history = useHistory();

  if(!isSuccess ) { return (<></>) }

  return(<>
      <Title main={publisher.name} sub={t('credentials')}  onBack={()=>(history.push(`/dashboard`))}></Title>
      <CredentialBlock publisher={publisher}/>
  </>)
}

export default Credentials
